import { render } from "./plansValue.vue?vue&type=template&id=66c42cff&scoped=true"
import script from "./plansValue.vue?vue&type=script&lang=js"
export * from "./plansValue.vue?vue&type=script&lang=js"

import "./plansValue.vue?vue&type=style&index=0&id=66c42cff&lang=scss&scoped=true"

import exportComponent from "D:\\changDa\\w3c\\www-clothing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c42cff"]])

export default __exports__